import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'

// Global options to prevent layout shift when modal opens
const options = {
  scrollbarPadding: false, // Prevents body padding adjustment when scrollbar hides
  heightAuto: false, // Prevents setting height:auto on body/html which causes footer jump
}

Vue.use(VueSweetalert2, options)
